import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import { selectWsDetail } from 'store/Workspace/selectors';
import { showUpdateModal } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { Wrapper, InputTitle, IconWorkspace } from './styled';
import { LockIcon } from 'Screens/Contextualization/Workspaces/components/Table/LockUnlockWs/styled';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_WORKSPACES, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const Title = () => {
  const dispatch = useDispatch();
  const workspaceDetail = useSelector(selectWsDetail);
  const currentName = get(workspaceDetail, 'name', '');
  const [wsName, setWsName] = useState(workspaceDetail.name);
  const readOnly = get(workspaceDetail, 'readonly', false);
  const canUpdate = useSelector((state) => selectAllowedByRole(state, FEATURE_WORKSPACES, PERMISSION_TYPES.UPDATE));
  const disabled = !canUpdate;
  const currentNameRef = useRef(currentName);

  const onClick = () => dispatch(showUpdateModal());

  useEffect(() => {
    setWsName(workspaceDetail.name);
  }, [workspaceDetail]);

  useEffect(() => {
    currentNameRef.current = currentName;
  }, [currentName]);

  return (
    <Wrapper onClick={ onClick }>
      <IconWorkspace />
        <InputTitle value={ wsName } disabled={ disabled } />
      { readOnly && <LockIcon title="This Workspace is locked (read-only)" /> }
    </Wrapper>
  );
};

export default Title;
